import {BaseApi} from "@/http/api/BaseApi";
import {redirect} from "next/navigation";
import Cookies from "js-cookie";
import {persianToEnglishNumber} from "@/hook/usePersianNumberInput";
import {PasswordAuth, RequestAuth, VerifyAuth} from "@/types/api/auth";
import errorHandler from "@/providers/ErrorHandler";


export default class AuthenticationServices extends BaseApi {


    request = async (contact: string): Promise<RequestAuth> => {
        try {
            const response: any = await this.post("auth/request", {contact: persianToEnglishNumber(contact)})
            if (response?.status || response.status === 200) {
                return response;
            } else {
                throw response
            }
        } catch (error: any) {
            errorHandler({message: error.contact});
            return Promise.reject(error);
        }
    }
    verify = async (otp: string, contact: string): Promise<VerifyAuth> => {
        try {
            const response : any = await this.post("auth/verify", {
                token: persianToEnglishNumber(otp),
                contact: persianToEnglishNumber(contact),
            })
            if (response?.status || response.status === 200) {
                return response;
            } else {
                throw response
            }
        } catch (error : any) {
            errorHandler({message: error.contact ?? error});
            return Promise.reject(error);
        }
    }
    login = async (password: string, contact: string): Promise<PasswordAuth> => {
        try {
            const response: any = await this.post("auth/login", {
                contact: persianToEnglishNumber(contact),
                password
            })
            if (response?.status || response.status === 200) {
                return response;
            } else {
                throw response
            }

        } catch (error : any) {
            console.log(error)
            errorHandler({message: error.contact ?? error});
            return Promise.reject(error);
        }
    }
    isVerify = async (token: string | unknown) => {
        if (!token) return null;
        try {
            return await this.get("auth/resend-verification", {
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                cache: "no-cache"
            });
        } catch (error) {
            console.log(error)
            // const allCookies = Cookies.get();
            // for (const cookieName in allCookies) {
            //     Cookies.remove(cookieName);
            // }
            // redirect("/auth");
        }
    }
}








